/** Chạy trên trang của người khác: mọi API trình duyệt có thể bị chặn
 *  (localStorage trong iframe sandbox, crypto trên http), nên chỗ nào cũng
 *  phải có đường lui. */

export function uid(prefix = ""): string {
  const c = globalThis.crypto as Crypto | undefined;
  if (c && typeof c.randomUUID === "function") return prefix + c.randomUUID();
  if (c && typeof c.getRandomValues === "function") {
    const bytes = c.getRandomValues(new Uint8Array(16));
    let out = "";
    for (let i = 0; i < bytes.length; i++) out += (bytes[i] as number).toString(16).padStart(2, "0");
    return prefix + out;
  }
  return prefix + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

/** Gộp nông, bỏ qua undefined — để `{ title: undefined }` không xoá mất giá
 *  trị đã có từ lớp cấu hình dưới. */
export function assignDefined<T extends object>(target: T, ...sources: Array<Partial<T> | undefined>): T {
  for (const source of sources) {
    if (!source) continue;
    for (const key of Object.keys(source) as Array<keyof T>) {
      const value = source[key];
      if (value !== undefined) target[key] = value as T[keyof T];
    }
  }
  return target;
}

export function joinUrl(base: string, path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  if (!base) return path;
  return base.replace(/\/+$/, "") + "/" + path.replace(/^\/+/, "");
}

export function toError(value: unknown): Error {
  if (value instanceof Error) return value;
  return new Error(typeof value === "string" ? value : JSON.stringify(value));
}

/** Đọc số từ thuộc tính data-*, trả undefined nếu không phải số. */
export function num(value: string | null | undefined): number | undefined {
  if (value == null || value === "") return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

export function bool(value: string | null | undefined): boolean | undefined {
  if (value == null || value === "") return undefined;
  if (value === "true" || value === "1" || value === "yes") return true;
  if (value === "false" || value === "0" || value === "no") return false;
  return undefined;
}

/** JSON trong thuộc tính data-* của khách — hỏng thì bỏ qua, không nổ. */
export function json<T>(value: string | null | undefined): T | undefined {
  if (!value) return undefined;
  try {
    return JSON.parse(value) as T;
  } catch {
    return undefined;
  }
}
